<template>
  <div>
    <cc-form-box :form-type="formType" @add="onAdd" @edit="onEdit"></cc-form-box>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import ccFormBox from '@/components/PettyCash/Certificate/ccFormBox.vue';

export default {
  name: 'ccForm',
  components: {
    ccFormBox
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  mounted() {
    if (this.$route.name === 'cc-form-new') {
      this.formType = 'new';
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;
    }
  },
  methods: {
    ...mapActions('pettyCash', ['postOneCertificate', 'patchCertificate']),
    onAdd(certificate) {
      this.postOneCertificate({
        certificate: certificate,
        router,
        redirectUrl: '/petty-cash/certificate/cc/upload'
      });
    },
    onEdit({ certificate }) {
      this.patchCertificate({
        id: this.id,
        newCertificate: certificate,
        router: this.$router,
        redirectUrl: '/petty-cash/certificate/cc/upload'
      });
    }
  }
};
</script>
